export const OAUTH_ACCESS_TOKEN = 'chatblk_access_token';
export const BASE_CHATBLK_API_PATH = '/api/ux/ai/chatblk';
export const BLK_API_PATHS = {
    BASE_CHATBLK_API_PATH,
    CHAT_EXCHANGE: `${BASE_CHATBLK_API_PATH}/chat-exchange/v1/chatExchangeSync:generate`,
    FEEDBACK: `${BASE_CHATBLK_API_PATH}/chatblk-feedback/v1/chatblkFeedbacks`,
    UI_EVENT: `${BASE_CHATBLK_API_PATH}/chatblk-ui/v1/chatblkUis`,
    RECENT_PROMPTS: `${BASE_CHATBLK_API_PATH}/prompt/v1/prompts:filter`,
    SUMMARIZE: `${BASE_CHATBLK_API_PATH}/summary/v1/summaries:filter`,
    BMS: '/weblications/bms/getUserBmsServer.epl',
    RELATIONSHIP_MANAGER: `${BASE_CHATBLK_API_PATH}/relationship-manager/v1/relationshipManagers:filter`,
};
export const DEFAULT = {
    HEADERS: {
        'Content-Type': 'application/json',
    },
    INITIALS: 'BR',
    USERNAME: 'Blake Rocco',
    NAME: 'BlackRock',
};
export const URIS = {
    BLK_HOST: 'www.blackrock.com',
    PROD_HOSTS: [
        'www.blackrock.com',
        'azrc.blackrock.com',
        'preview.blackrock.com',
        'testc.blackrock.com',
        'devc.blackrock.com',
    ],
    PRE_PROD_HOSTS: ['localhost', 'dev.blackrock.com', 'tst.blackrock.com'],
    TEST_SUMMARY:
        'https://www.blackrock.com/us/financial-professionals/insights/private-markets-investing',
    SUMMARIZE_HOSTNAME: 'https://www.blackrock.com',
    PRE_PROD_LOGIN_PATH:
        '/financial-professionals/financial-professionals/sign-on.oauth?redirectUrl=%2ffinancial-professionals%2ffinancial-professionals%3FsignInAppWithOkta%3Dtrue',
    PROD_LOGIN_PATH:
        '/us/financial-professionals/sign-on.oauth?redirectUrl=%2fus%2ffinancial-professionals%3FsignInAppWithOkta%3Dtrue',
};
export const XHR = {
    RESPONSE_ID_REGEX: /vnd.+response-id/i,
    API_KEY: 'VND.com.blackrock.API-Key',
    AUTH: 'Authorization',
    TIMESTAMP: 'Timestamp',
    TRACEPARENT: 'TraceParent',
    ORIGIN_TIMESTAMP: 'VND.com.blackrock.Origin-Timestamp',
    REQUEST_ID: 'VND.com.blackrock.Request-ID',
    RESPONSE_ID: 'VND.com.blackrock.Response-ID',
};
